import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import type { GridSummaryRow } from '../types';
import { usePlanStrategy } from './strategy';

export function useGridSummaryRows(): GridSummaryRow[] {
  const strategy = usePlanStrategy();
  const summary = useAtomValue(strategy.summary.grid);
  return useMemo(() => [{ summary }], [summary]);
}
